import type { Lead } from '../../services/leadSyncService';
import type { StatusTone } from '../../components/ui';

export const LEAD_STATUS: Record<string, { label: string; tone: StatusTone }> = {
  new: { label: 'Neu', tone: 'info' },
  enriched: { label: 'Angereichert', tone: 'info' },
  synced: { label: 'In Kampagne', tone: 'success' },
  active: { label: 'Aktiv', tone: 'success' },
  inactive: { label: 'Inaktiv', tone: 'neutral' },
};

export const LEMLIST_STATUS: Record<string, { label: string; tone: StatusTone }> = {
  synced: { label: 'In Kampagne', tone: 'success' },
  error: { label: 'Fehler', tone: 'danger' },
  unsubscribed: { label: 'Abgemeldet', tone: 'warning' },
};

export const LEAD_QUELLE: Record<string, string> = {
  manual: 'Manuell',
  csv: 'CSV-Import',
  linkedin: 'LinkedIn',
  clay: 'Clay',
  kampagne: 'Kampagne',
};

export const leadStatus = (status: string) => LEAD_STATUS[status] ?? { label: status, tone: 'neutral' as StatusTone };
export const lemlistStatus = (status?: string | null) => (status ? LEMLIST_STATUS[status] ?? { label: status, tone: 'neutral' as StatusTone } : null);
export const quelleLabel = (quelle?: string | null) => (quelle ? LEAD_QUELLE[quelle] ?? quelle : '—');

export const leadName = (lead: Pick<Lead, 'firstName' | 'lastName' | 'email'>) =>
  [lead.firstName, lead.lastName].filter(Boolean).join(' ') || lead.email;

/** tags liegt als JSON-Zeichenkette in der Datenbank. */
export const tagsAus = (lead: Pick<Lead, 'tags'>): string[] => {
  if (!lead.tags) return [];
  try {
    const wert = JSON.parse(lead.tags);
    return Array.isArray(wert) ? wert.map(String) : [];
  } catch {
    return lead.tags.split(',').map((t) => t.trim()).filter(Boolean);
  }
};
